import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { registerPublishedSqlDatasets } from 'tio-reporting/utils/sql-dataset-registration';
import type SessionContextService from 'tio-employee/services/session-context';
import type RouterService from '@ember/routing/router-service';
import type { Store as StoreService } from '@warp-drive/core';

const ALLOWED_ROLES = ['TIO_ADMIN', 'EMPLOYEE_ADMIN', 'ACCOUNT_OWNER'];

export default class AuthenticatedAdminReportingRoute extends Route {
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;
  @service declare store: StoreService;

  async beforeModel() {
    if (!this.sessionContext.isLoaded) {
      try {
        await this.sessionContext.load();
      } catch (e) {
        console.error('Could not load session context:', e);
      }
    }

    const hasAccess = this.sessionContext.roles.some((role) =>
      ALLOWED_ROLES.includes(role.relationshipType)
    );

    if (!hasAccess) {
      this.router.transitionTo('authenticated.dashboard');
      return;
    }

    // Register published SQL-backed datasets (RFC 062) so saved SQL-dataset
    // reports resolve in the report viewer — without this, isSqlDataset()
    // is false and the slug would be sent to /api/v2/search as a model
    // type. The backend scopes the list to datasets this user may query.
    await registerPublishedSqlDatasets(this.store);
  }
}
